import React from 'react';
import './CommonButton.css';

const CommonButton = ({ 
        size = 'medium', 
        presetStyle = 'dark', 
        customClass = {}, 
        onClick = () => {}, 
        type = 'button',
        disabled = false,
        children
    }) => {
    return (
        <button
            className={`common-button ${size} ${presetStyle === 'dark' ? 'common-button--dark' : 'common-button--light'} 
            ${customClass}`}
            onClick={onClick}
            type={type}
            disabled={disabled}
        >
            {children}
        </button>
    );
};

export default CommonButton;